import { RobotoSwitch, RobotoTooltip } from "@/shared/components";
import { UpdateActionRequest } from "@/shared/domain/actions/ActionRecord";

export interface DownloadInputsSwitchProps {
  /**
   * Whether the switch is checked.
   */
  checked: boolean;

  /**
   * Called when switch is toggled.
   *
   * @param updates the values to modify in the record
   */
  onChange: (updates: UpdateActionRequest) => void;
  /**
   * Propagates an action update error message.
   *
   * @param errorText the error message
   */
  setErrorText: (errorText: string | null) => void;
}

export function DownloadInputsSwitch({
  checked,
  onChange,
  setErrorText,
}: DownloadInputsSwitchProps) {
  function updateRecord() {
    setErrorText("");

    onChange({
      requires_downloaded_inputs: !checked,
    });
  }

  return (
    <RobotoTooltip
      title={checked ? "Download Inputs" : "Don't Download Inputs"}
    >
      <RobotoSwitch
        checked={checked}
        color="success"
        inputProps={{ "aria-label": "download inputs" }}
        onChange={() => {
          void updateRecord();
        }}
      />
    </RobotoTooltip>
  );
}
